import { QueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'
import { CurrencyCode, Money } from '@percent/utility'

type DonationSummaryParams = {
  currencyCode: CurrencyCode
  startDate?: Date
  endDate?: Date
}

export type WalletFundingSourceAmount = {
  fundingSourceId: string | null
  fundingSourceName: string | null
  amount: Money
}

export type DonationSummaryResponse = {
  totalDonated: Money
  donated: Money
  matched?: Money
  wallet?: Money
  walletByFundingSource?: WalletFundingSourceAmount[]
}

export const donationSummary: QueryFn<[string, DonationSummaryParams], DonationSummaryResponse> = async (
  client,
  [_, params]
) => {
  const response = await client.get<{ data: DonationSummaryResponse }>('v1/account/donations/donation-summary', {
    params
  })

  return response.data.data
}
